"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiCreateGroupDescription } from "@/generated/models/ApiCreateGroupDescription";
import GroupCreateDirection from "./common/GroupCreateDirection";
import IdentitySearch, { IdentitySearchSize } from "@/components/utils/input/identity/IdentitySearch";
import GroupCreateNumericValue from "./common/GroupCreateNumericValue";
import RepCategorySearch, { RepCategorySearchSize } from "@/components/utils/input/rep-category/RepCategorySearch";
import { ApiGroupFilterDirection } from "@/generated/models/ApiGroupFilterDirection";
import { useState } from "react";
import PositiveOnlyToggle from "./rep/PositiveOnlyToggle";
export default function GroupCreateRep(t0) {
  const $ = _c(34);
  const {
    rep,
    setRep
  } = t0;
  const [positiveOnly, setPositiveOnly] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      [ApiGroupFilterDirection.Received]: "From Identity",
      [ApiGroupFilterDirection.Sent]: "To Identity"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const IDENTITY_LABEL = t1;
  const identityLabel = rep.direction ? IDENTITY_LABEL[rep.direction] : "Identity";
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div><p className="tw-mb-0 tw-text-base sm:tw-text-lg tw-font-semibold tw-text-iron-50">Rep</p><p className="tw-mt-1 tw-mb-0 tw-text-sm tw-font-normal tw-text-iron-300">Set the giver, rep category, and minimum rep.</p></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== positiveOnly) {
    t3 = <div className="tw-mb-4 tw-flex tw-items-center tw-justify-between">{t2}<PositiveOnlyToggle positiveOnly={positiveOnly} setPositiveOnly={setPositiveOnly} /></div>;
    $[2] = positiveOnly;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== rep || $[5] !== setRep) {
    t4 = rep.user_identity && rep.direction && <div className="tw-mb-4"><GroupCreateDirection direction={rep.direction} label="Rep" setDirection={direction => setRep({
        ...rep,
        direction
      })} /></div>;
    $[4] = rep;
    $[5] = setRep;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== rep || $[8] !== setRep) {
    t5 = identity => setRep({
      ...rep,
      user_identity: identity
    });
    $[7] = rep;
    $[8] = setRep;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== identityLabel || $[11] !== rep.user_identity || $[12] !== t5) {
    t6 = <IdentitySearch size={IdentitySearchSize.MD} identity={rep.user_identity} label={identityLabel} setIdentity={t5} />;
    $[10] = identityLabel;
    $[11] = rep.user_identity;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== rep || $[15] !== setRep) {
    t7 = category => setRep({
      ...rep,
      category
    });
    $[14] = rep;
    $[15] = setRep;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== rep.category || $[18] !== t7) {
    t8 = <RepCategorySearch size={RepCategorySearchSize.MD} category={rep.category} setCategory={t7} />;
    $[17] = rep.category;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t6 || $[21] !== t8) {
    t9 = <div className="tw-flex tw-flex-col xl:tw-flex-row tw-gap-4 lg:tw-gap-5">{t6}{t8}</div>;
    $[20] = t6;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== rep || $[24] !== setRep) {
    t10 = value => setRep({
      ...rep,
      min: value
    });
    $[23] = rep;
    $[24] = setRep;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== rep.min || $[27] !== t10) {
    t11 = <div className="tw-mt-4 lg:tw-mt-5"><GroupCreateNumericValue value={rep.min} label="Rep at least" labelId="floating_rep" setValue={t10} /></div>;
    $[26] = rep.min;
    $[27] = t10;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t11 || $[30] !== t3 || $[31] !== t4 || $[32] !== t9) {
    t12 = <div className="tw-p-3 sm:tw-p-5 tw-bg-iron-950 tw-rounded-xl tw-shadow tw-border tw-border-solid tw-border-iron-800"><div className="tw-flex tw-flex-col tw-space-y-4"><div className="tw-flex tw-flex-col">{t3}{t4}{t9}{t11}</div></div></div>;
    $[29] = t11;
    $[30] = t3;
    $[31] = t4;
    $[32] = t9;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  return t12;
}